<template>
	<NoLineBreaks v-if="maxCount == null">{{ $t('license.fields.withoutRestrictions') }}</NoLineBreaks>
	<div v-else>
		<NoLineBreaks>{{ $t('license.fields.baseStationsMaxCount') }} {{ maxCount }}</NoLineBreaks>
		<NoLineBreaks>{{ $t('license.fields.baseStationsWorkingCount') }} {{ workingCount }}</NoLineBreaks>
	</div>
</template>

<script>
import NoLineBreaks from '@/components/common/NoLineBreaks';

export default {
	components: {
		NoLineBreaks,
	},
	props: ['workingCount', 'maxCount'],
}
</script>